export default __webpack_public_path__ + "static/media/connect-4.d24573b7.png";